exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-center[data-v-23099ab8] {\n  margin: 0px auto;\n  position: relative;\n}\n", ""]);

// exports
